export default ($resource) => {
    const base = `${SEED_CORE.ENV.API_URL}event/event`;
    const url = `${base}/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        duplicate: {
            method: 'POST',
            url: `${url}/duplicate`
        },
        delete: {
            method: 'DELETE',
            url
        },
        templates: {
            method: 'GET',
            url: `${url}/template`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Event/index.js